export default {"src":"/_next/static/media/searchNotFound.b69fee08.svg","height":246,"width":296,"blurWidth":0,"blurHeight":0};